import { Type } from "js-yaml";
import { CUSTOM_TAGS } from "../constants.js";
class ParsedMd {
  key;
  isMarkdown = true;
  constructor(key) {
    this.key = key;
    this.isMarkdown = true;
  }
}
const MdTag = new Type(CUSTOM_TAGS.MD, {
  kind: "scalar",
  resolve: (data) => data !== null && typeof data === "string",
  construct: (data) => new ParsedMd(data),
  instanceOf: ParsedMd,
  represent: (data) => data.key
});
export {
  MdTag,
  ParsedMd
};
